export default __webpack_public_path__ + "static/media/F0002.df966d02.png";